import { useState } from 'react';

export function JoinScreen({ onJoin }) {
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setLoading(true);
    try {
      await onJoin(code.trim(), name.trim() || undefined);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="join-screen">
      <div className="join-logo">🧊</div>
      <h1 className="join-title">FridgeBuddy</h1>
      <p className="join-subtitle">
        Dein virtueller Kühlschrank. Beleg scannen, Haltbarkeit im Blick, weniger wegwerfen.
      </p>

      <form className="join-form" onSubmit={handleSubmit}>
        <input
          className="input"
          type="text"
          placeholder="Haushalt-Code"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          maxLength={20}
          autoFocus
        />
        <input
          className="input"
          type="text"
          placeholder="Haushaltsname (optional)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{ fontSize: '15px', letterSpacing: 'normal', textTransform: 'none' }}
        />
        <button
          className="btn btn-primary btn-block"
          type="submit"
          disabled={!code.trim() || loading}
          style={{ marginTop: 8 }}
        >
          {loading ? 'Verbinden...' : 'Haushalt beitreten / erstellen'}
        </button>
      </form>

      <p style={{ marginTop: 24, fontSize: 13, color: 'var(--gray-400)', maxWidth: 280 }}>
        Gib einen Code ein, um einem bestehenden Haushalt beizutreten, oder wähle einen neuen Code um deinen eigenen zu erstellen.
      </p>
    </div>
  );
}
